import { OASPhysicianProfile } from '../features/profile/profile';

export default OASPhysicianProfile;
